import script from "./ScheduleWeekFilterButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleWeekFilterButtons.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleWeekFilterButtons.vue?vue&type=style&index=0&id=14228949&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14228949"]])

export default __exports__